import { validateOperationsSearch } from '@ops/features/operations-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

export const operationsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'operations',
  component: lazyRouteComponent(() =>
    import('@ops/pages/operations').then((m) => ({
      default: m.OperationsPage,
    }))
  ),
  validateSearch: (input: Record<string, unknown>) =>
    validateOperationsSearch(input),
});
